import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Store } from '../../../store';
import { TwilioService } from '../../../services/twilio.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { filter, first } from 'rxjs/operators';
import { defaultOrderSearchParams } from '../../../data-types/search-params';
import { HttpClient } from '@angular/common/http';
import { OrdersService } from '../../../services/orders.service';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { format } from 'date-fns';
import { CallCenterComponent } from '../call-center.component';
import { CallDataType, defaultCallDataToggle } from '../../../state';
import { MenuService } from '../../../services/menu.service';

@Component({
    selector: 'app-call-bar',
    templateUrl: './call-bar.component.html',
    styleUrls: ['./call-bar.component.scss'],
    animations: [
        trigger('fadeIn', [
            state('void', style({ opacity: '0' })),
            transition('void <=> *', [animate('200ms ease-in')]),
        ]),
    ],
})
export class CallBarComponent implements OnInit {
    @Input() controllingComponent: CallCenterComponent | null = null;
    // 'part-of' if when bar is a pard of other component, has no controls etc.

    user = this.store.selectForLocal('user');
    public message: any = {
        name: '',
        content: '',
        recipient: [],
        recipientType: '',
        category: 0,
    };

    public contactOrderList$$: BehaviorSubject<Array<any>> = new BehaviorSubject([]);
    callDetails$ = this.store.select<CallDataType>('call');

    constructor(
        public store: Store,
        public twilioService: TwilioService,
        private http: HttpClient,
        private ordersService: OrdersService,
        private router: Router,
        private menuService: MenuService
    ) {}

    ngOnInit(): void {
        this.twilioService.onLineContact$$
            .pipe(
                filter((data) => data === null && this.twilioService.isInboundCall) // only for inbound call
            )
            .subscribe(() => {
                this.twilioService.onLinePhoneNr$$.pipe(filter((phone: any) => phone)).subscribe((toPhone) => {
                    this.twilioService.searchContacts(toPhone)
                        .pipe(filter(item => !!item))
                        .subscribe((contactResult) => {
                        this.twilioService.contact = contactResult;
                        this.ordersService
                            .searchOrderDetails({
                                ...defaultOrderSearchParams,
                                customerId: contactResult.id,
                            })
                            .subscribe((oderResult) => {
                                let orderToFlash = null; // flashing order only on overdue
                                this.contactOrderList$$.next(oderResult.data);
                                oderResult.data.forEach((item) => {
                                    if (item.dueDays < 0) {
                                        if (orderToFlash && orderToFlash.dueDays > item.dueDays) {
                                            orderToFlash = item;
                                        } else {
                                            orderToFlash = item;
                                        }
                                    }
                                });
                            });
                    });
                });
            });
    }

    muteCall(): void {
        if (this.twilioService.isOutboundCallGoingOn) {
            this.twilioService.toggleMuteOutboundCall();
        } else {
            this.twilioService.toggleMuteInboundCall();
        }
    }

    toggleOrderDetails() {
        this.store.setProp<CallDataType>('call', {
            ...defaultCallDataToggle,
            showOrderDetails: !this.store.selectForLocal('call').showOrderDetails,
        });
    }

    toggleAvailableAgents() {
        this.store.setProp<CallDataType>('call', {
            ...defaultCallDataToggle,
            showAvailableAgents: !this.store.selectForLocal('call').showAvailableAgents,
        });
    }

    startChat(): void {
        this.twilioService.onLineContact$$
            .pipe(
                filter((contact: any) => contact),
                first()
            )
            .subscribe((contact) => {
                const timeDate = format(new Date(), "yyyy-MM-dd'T'HH:mm:ssxxx");
                this.router.navigate([
                    '/mail',
                    {
                        compose2Id: contact.id,
                        subject: `Reference call with ${this.user.contact.firstname} ${this.user.contact.surname} at ${timeDate}`,
                    },
                ]);
            });
    }

    pickUpInboundCall() {
        if (this.store.selectForLocal('domain')) {
            this.menuService.setDomain(this.twilioService.activeTwilioDomain);
        }
        this.twilioService.pickUpInboundCall();
    }

    addContact(): void {
        this.twilioService.onLinePhoneNr$$
            .pipe(
                filter((phone: any) => phone),
                first()
            )
            .subscribe((toPhone) => {
                this.router.navigate(['/accounts', 'calls', { newCustomerMob: toPhone }]);
            });
    }

    get onTheLine(): boolean {
        return this.twilioService.isOutboundCallGoingOn || this.twilioService.isInboundCallGoingOn;
    }
}
